export default theme => ({
  root: {},
  formControl: {
    margin: theme.spacing(1),
    minWidth: '200px',
    width: '200px',
  },
  rowWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    margin: theme.spacing(0),
    alignItems: 'baseline',
  },
  formControlMedium: {
    margin: theme.spacing(1),
    minWidth: '150px',
    width: '150px',
  },
  formControlSmall: {
    margin: theme.spacing(1),
    minWidth: '100px',
    width: '100px',
  },
  formControlAutoComplete: {
    margin: theme.spacing(1),
    minWidth: '200px',
    width: '200px',
    top: '-1rem'
  }
});
